"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CharTypesEnum_1 = require("../constants/CharTypesEnum");
var buildInputStrings_1 = require("./buildInputStrings");
function inputValue(params) {
    var data = params.data, _a = params.input, input = _a === void 0 ? '' : _a, selection = params.selection, mask = params.mask, maskChar = params.maskChar, maskString = params.maskString, showStartChars = params.showStartChars;
    var _b = buildInputStrings_1.buildInputStrings(data, mask, input, maskChar, maskString, selection), value = _b.value, maskedValue = _b.maskedValue, inputValuesApplied = _b.inputValuesApplied;
    var selectionPosition = selection.start + inputValuesApplied;
    // remove all leading maskChar
    var bound = value.length - 1;
    var charsCount = 0;
    while (bound >= 0 && value[bound].type !== CharTypesEnum_1.CharTypes.USER) {
        if (value[bound].type === CharTypesEnum_1.CharTypes.MASK) {
            charsCount = 0;
        }
        if (value[bound].type === CharTypesEnum_1.CharTypes.CHAR) {
            charsCount++;
        }
        bound--;
    }
    if (showStartChars || bound >= 0 || (input && input.trim())) {
        bound += charsCount;
    }
    var visibleValue = '';
    for (var i = 0; i <= bound; i++) {
        visibleValue += value[i].char;
    }
    return {
        value: value,
        visibleValue: visibleValue,
        maskedValue: maskedValue,
        selection: {
            start: selectionPosition,
            end: selectionPosition,
        },
    };
}
exports.default = inputValue;
